import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"

const MoreFeaturesSection = () => {
  return (
    <div className="w-full bg-gradient_bottom_page rounded-b-[50px] md:rounded-b-[100px] px-4 md:px-px1_l xl:px-px1_xl pb-[60px] md:pb-[70px] lg:pb-[116px] md:mt-[40px] lg:mt-[60px] xl:mt-[80px]">
      {/* White Container */}
      <CMSRender
        contentType="OtherFeaturesSection"
        renderItem={(data, id) => {
          return (
            <div 
              key={id} 
              className="w-full max-w-[510px] md:max-w-[860px] lg:max-w-w1_xl flex flex-col items-center justify-center bg-paper rounded-[50px] md:rounded-[56px] lg:rounded-[70px] lg:px-[50px] xl:px-[80px] pt-[70px] pb-[76px] mx-auto"
            >
              {/* Heading */}
              <Typography
                component="h2"
                variant="h1" 
                className="text-text text-center mb-[30px]"
              >
                {data.title}
              </Typography>

              {/* Description */}
              <Typography
                variant="body1" 
                className="text-text text-center max-w-[600px] md:max-w-[700px] lg:max-w-[860px] my-0"
              >
                {data.description}
              </Typography>

              {/* Cards */}
              <div className="w-full flex flex-wrap lg:flex-nowrap justify-center lg:justify-between md:gap-x-[60px] gap-y-[50px] lg:gap-y-0 mt-[68px]">
                {data.cards.map((card, index) => (
                  <div
                    key={index}
                    className="flex flex-col items-center text-center w-full max-w-[150px] md:max-w-[180px] lg:max-w-[236px]"
                  >
                    {/* Card Icon */}
                    <div className="w-[70px] h-[70px] text-primary mb-[12px]">
                      <img
                        src={card.icon}
                        alt="icon"
                        className="w-[full] h-[auto]"
                      />
                    </div>

                    {/* Card Title */}
                    <Typography
                       variant="body1_accent" 
                       className="mb-[8px]">
                      {card.title}
                    </Typography>
                  </div>
                ))}
              </div>
            </div>
          )
        }}
      />
    </div>
  )
}

export default MoreFeaturesSection
